import React, { useRef } from 'react'
import PropTypes from 'prop-types'
import {
  ACCESS_CODES,
  getProgramPreferencesFromArray,
} from 'utils/sitePreferenceHelpers'
import K8DigitalProgramCardV2 from './component'

export const K8DigitalProgramCardV2Container = props => {
  const {
    content,
    contentfulCourses,
    currentSite,
    entryId,
    firstTimeMS,
    isK5Product,
    isMsProduct,
    onComponentClick,
    ...otherProps
  } = props
  // Extract lesson completion goal value from currentSite based on program type
  const accessCode = isK5Product
    ? ACCESS_CODES.K5
    : isMsProduct
    ? ACCESS_CODES.MSP
    : null
  const programPreferences = accessCode
    ? getProgramPreferencesFromArray(currentSite?.preferences, { accessCode })
    : {}
  const lessonCompletionGoalValue =
    programPreferences?.lessonCompletionGoalValue ?? null

  // FirstTimeClasses ref and handler
  const createCourseRef = useRef(null)

  const createSmallGroupRef = useRef(null)

  // Handle create class button click
  const handleCreateClassClick = () => {
    if (createCourseRef.current) {
      const button = createCourseRef.current.querySelector(
        '[data-testid="button-create"]',
      )
      if (button) {
        button.click()
      }
    }
  }

  const handleCreateSmallGroupClick = () => {
    if (createSmallGroupRef.current) {
      const button = createSmallGroupRef.current.querySelector(
        '[data-testid="button-create-small-group"]',
      )
      if (button) {
        button.click()
      }
    }
  }
  // Determine if we should show FirstTimeClasses
  const showFirstTimeClasses = firstTimeMS && !!entryId

  // Handle training click - check URL for grade level and redirect accordingly
  const onTrainingClick = () => {
    const url = window.location.href

    // Check if the URL contains grade level indicators
    if (url.includes('k-5') || url.includes('k5')) {
      onComponentClick('/product/elementary/trainings')
    } else if (url.includes('6-8') || url.includes('68')) {
      onComponentClick('/product/middle-school/trainings')
    } else {
      // Fallback - just log that no grade level was found
      console.warn('No grade level found in URL for training redirect:', url)
    }
  }

  // Handle Tier 2 Resources click
  const onTier2ResourcesClick = () => {
    if (isK5Product) {
      onComponentClick('/product/elementary/intervention-resources')
    } else if (isMsProduct) {
      onComponentClick('/product/middle-school/intervention-resources')
    } else {
      console.warn(
        'Unable to determine product type for Intervention Resources redirect',
      )
    }
  }

  return (
    <K8DigitalProgramCardV2
      {...otherProps}
      contentfulCourses={contentfulCourses}
      createCourseRef={createCourseRef}
      createSmallGroupRef={createSmallGroupRef}
      handleCreateClassClick={handleCreateClassClick}
      handleCreateSmallGroupClick={handleCreateSmallGroupClick}
      isK5Product={isK5Product}
      isMsProduct={isMsProduct}
      lessonCompletionGoalValue={lessonCompletionGoalValue}
      onComponentClick={onComponentClick}
      onTier2ResourcesClick={onTier2ResourcesClick}
      onTrainingClick={onTrainingClick}
      showFirstTimeClasses={showFirstTimeClasses}
      tier2ResourcesLabel="Intervention Resources"
    />
  )
}

K8DigitalProgramCardV2Container.propTypes = {
  content: PropTypes.object,
  contentfulCourses: PropTypes.array,
  currentSite: PropTypes.shape({
    preferences: PropTypes.array,
  }),
  entryId: PropTypes.string,
  firstTimeMS: PropTypes.bool,
  isK5Product: PropTypes.bool,
  isMsProduct: PropTypes.bool,
  onComponentClick: PropTypes.func,
}

export default K8DigitalProgramCardV2Container
